import React, { useState } from "react";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Connection = ({ activity }) => {
  const [status, setstatus] = useState("All");
  const navigate = useNavigate();
  return (
    <>
      {activity ? (
        <>
          <table className="plan_table mt-24">
            <thead className="plan_thead activityplan_thead">
              <div className="">
                <p className="" htmlFor="typeDropdown">
                  Select status
                </p>
                <select
                  id="typeDropdown"
                  className="h-40px"
                  value={status}
                  onChange={(e) => setstatus(e.target.value)}
                >
                  <option value="All">All</option>
                  <option value="Accepted">Accepted</option>
                  <option value="Requested">Requested</option>
                </select>
                (
                {
                  activity.filter((lead) => {
                    if (status === "All") return lead;
                    else if (lead.isAccepted && status === "Accepted")
                      return lead;
                    else if (!lead.isAccepted && status === "Requested")
                      return lead;
                  }).length
                }
                )
              </div>
              <tr>
                <th>Sender</th>
                <th>Receiver</th>
                <th>Time</th>
                <th>Status</th>
              </tr>
            </thead>
            {activity.length > 0 &&
              activity
                .filter((lead) => {
                  if (status === "All") return lead;
                  else if (lead.isAccepted && status === "Accepted")
                    return lead;
                  else if (!lead.isAccepted && status === "Requested")
                    return lead;
                })
                .map((res, i) => (
                  <tr key={i} className="my-2 pt-2">
                    <td
                      onClick={() =>
                        navigate(
                          `/admin/user-activity?tab=13&userid=${res.sender?._id}`
                        )
                      }
                      className="pointer my-2 pt-2"
                    >
                      <Avatar src={res.sender ? res.sender.avatar : ""} />
                      {res.sender
                        ? `${res.sender.name} (${res.senderType})`
                        : ""}
                    </td>
                    <td
                      onClick={() =>
                        navigate(
                          `/admin/user-activity?tab=13&userid=${res.receiver?._id}`
                        )
                      }
                      className="pointer my-2 pt-2"
                    >
                      <Avatar src={res.receiver ? res.receiver.avatar : ""} />
                      {res.receiver
                        ? `${res.receiver.name} (${res.receiverType})`
                        : ""}
                    </td>
                    {res.lastConnectedAt ? (
                      <td className=" pt-2">
                        Accepted at
                        {new Date(res.lastConnectedAt).toLocaleTimeString()}
                        {new Date(res.lastConnectedAt).toLocaleDateString()}
                      </td>
                    ) : res.lastRequestedAt ? (
                      <td className=" pt-2">
                        Requested at
                        {new Date(res.lastRequestedAt).toLocaleTimeString()}
                        {new Date(res.lastRequestedAt).toLocaleDateString()}
                      </td>
                    ) : (
                      <td className=" pt-2">
                        {new Date(res.updatedAt).toLocaleTimeString()}
                        {new Date(res.updatedAt).toLocaleDateString()}
                      </td>
                    )}

                    <td className=" my-2 pt-2">
                      {res.isAccepted ? (
                        <span style={{ color: "green" }}>Accepted</span>
                      ) : (
                        <span style={{ color: "red" }}>Pending</span>
                      )}
                    </td>
                  </tr>
                ))}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Connection;
